// extracted by mini-css-extract-plugin
export default {"button":"CollapseButton_button__MP-dQ","iconArrow":"CollapseButton_iconArrow__gAIVD","iconList":"CollapseButton_iconList__j6gYU"};